import Component from '../core/Component'

export default class WatchdogProductDetail extends Component {
    constructor(element, options = {}) {
        super(element, options)
    
        this.ref = {
            arrow: null,
            form: null //mimo scope komponenty, queryselector na parenty
        }
    }

    prepare() {
        this.ref.form = this.element.closest('form')
        if (!this.ref.form) {
            return
        }

        this.ref.form.addEventListener('change', this.handleFormChange)
        this.update()
    }

    destroy () {
        if (this.ref.form) {
            this.ref.form.removeEventListener('change', this.handleFormChange)
        }
    }

    handleFormChange = () => {
        this.update()
    }
    
    update() {
        const label = this.ref.form.querySelector('.product-Sizes-input:checked')?.closest('.product-Sizes-label')
        if (!label) {
            this.ref.arrow.style.display = 'none'
            return
        }

        this.ref.arrow.style.display = 'block'
        this.ref.arrow.style.left = `${label.offsetLeft + label.offsetWidth / 2 }px`
    }
}